module.exports = __webpack_public_path__ + "static/img/BU02PB-4.21107ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU02PB-4.jpg
// module id = T6RJ
// module chunks = 1